import { ResponseGetMerchflow_merchflowId_FlowUpdateChangeSummary } from "@CommonApi/merchflow/_merchflowId_/flow-update/change-summary";
import { omniAtom } from "src/utils/atoms";

export const changeSummaryDataAtom = omniAtom({
  key: "changeSummary",
  value: null as null | ResponseGetMerchflow_merchflowId_FlowUpdateChangeSummary,
});
